import * as T from '^/types';

export default {
  createCategoryLabel: (label: string) => ({
    [T.Language.KO_KR]: `“${label}” 유형 새로 만들기`,
    [T.Language.EN_US]: `Create a new type labelled “${label}”`,
  }),
};
